import type { Metadata } from "next";
import { NotFoundContent } from "@/components/not-found-content";

export const metadata: Metadata = {
  title: "Page not found",
  robots: { index: false, follow: false },
};

/**
 * Not-found boundary for the (marketing) group. Rendered INSIDE the marketing
 * layout, so it reuses the single GlobalHeader + FullFooter (no duplicate
 * chrome). The root app/not-found.tsx still handles truly unmatched top-level
 * paths with its own minimal chrome.
 */
export default function MarketingNotFound() {
  return <NotFoundContent />;
}
